/**
 * Project: bicc-trafig
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2021-07-22 16:47:18
 * License: MIT License
 */


export default {
    min: {
        md: 480, lg: 768, xl: 1024, xxl: 2400
    },
    max: {
        sm: 575.98, md: 767.98, lg: 991.98, xl: 1199.98
    }
}
